import { gql } from '@ori/fetching';

export const customerQuery = gql`
  query GetCustomer {
    customer {
      firstName
      lastName
      emails {
        emailAddress
      }
      consultantNumber
      customerId
      phones {
        telephoneNumber
      }
      customerType {
        description
      }
    }
  }
`;
